import { h, } from "preact";
import { useState, useEffect } from "preact/hooks";
import { Alert, Box, Grid, Paper, Stack } from "@mui/material";

import RealEstateCarousel from "./RealEstateCarousel";

import Uploader from "../Uploader"
import SortableGridContainer from "../SortableGrid/SortableGridContainer";
import ContactSupportIcon from '@mui/icons-material/ContactSupport';

export default function Bien3({ upperState }) {

	const [upperStep, setUpperStep] = useState(undefined);
	const [state, setState] = useState(upperState);
	const setUpperActiveStep0 = (idx) => {
		//	console.log("setUpperActiveStep0", idx)
		setUpperStep(idx)
	};

	useEffect(() => {
		console.log("session_uid", state.session_uid)
		if (!state.session_uid) {
			const requestOptions = {
				method: "POST",
				headers: { "Content-Type": "application/json" },

				body: JSON.stringify({
					deal_uid: upperState.deal_uid
				}),
			};
			fetch("/upload/e48dcaabe83040548c5291e9d3b9d716/pics", requestOptions)
				.then((response) => {
					return response.json();
				})
				.then((res) => {
					switch (res.res) {
						case "ok":
							//reset
							console.log("has upload session");
							setState({ ...upperState, session_uid: res.pld });

							break;

						case "err":
							break;
						default:
							break;
					}
				});
		}
	}, []);

	const updateItems = (items) => {
		console.log("updateitems", items)
		setState((previous_state) => ({ ...previous_state, pics: items }))
	};

	return (
		<Grid container spacing={2} alignItems="stretch">
			{!state.is_uploading && upperState.pics && upperState.pics.length > 0 && (<Grid item xs={12} md={6}>
				<Stack spacing={1} >

					<Box display="flex" justifyContent="center" alignItems="center">
						<Paper style="padding: 5px;">
							<RealEstateCarousel pics={state.pics} deal_uid={upperState.deal_uid} mode="RW" upperStep={upperStep} dim="main2" />
						</Paper>
					</Box>


				</Stack>
			</Grid>)}
			<Grid item xs={12} md={6} >

				<Stack spacing={1}>
					{upperState.pics.length < 30 && state.session_uid && <Uploader mode="pics" upperState={state} outerSetState={setState} />}
					{upperState.pics.length > 1 && <Stack spacing={1}>
						<Paper>
							<Alert
								severity={"info"}
								icon={<ContactSupportIcon color="primary" />} >
								Vous pouvez réorganiser l'ordre des photos en les déplaçant avec la souris
							</Alert>
						</Paper>
						<Paper style="padding: 5px; height: 100%">
							<SortableGridContainer updateItems={updateItems} setUpperActiveStep0={setUpperActiveStep0} uid={upperState.uid} items={state.pics.map((item) => { return { uid: item.uid, rn: item.rnk, cmt: item.cmt, link: item.link, link1: `${THUMBS_URL}/${upperState.deal_uid}/${item.link}-100.jpg` } })} />
						</Paper>
					</Stack>}
				</Stack>

			</Grid>

		</Grid >
	);
}
